(function () {
  var initialized = false;
  var retryCount = 0;
  var maxRetries = 30;
  var selectors = {
    productForm: '[data-js-product-form]',
    cartDrawer: '[data-section-modification="drawer"]',
    cartCount: '[data-js-cart-count], .cart-count, [data-cart-count], .js-header-cart-item-count',
    quantityError: '.js-product-quantity-error',
    quantityErrorWrapper: '.js-product-quantity-error-wrapper, .product-add-to-cart__error',
    submitButton: '[type="submit"]'
  };

  function init() {
    if (initialized) return;

    if (!document.querySelector(selectors.productForm)) {
      if (retryCount < maxRetries) {
        retryCount++;
        setTimeout(init, 500);
      }
      return;
    }

    document.addEventListener('submit', onProductFormSubmit, true);
    document.addEventListener('click', onBuyNowClick, true);
    initialized = true;
  }

  async function onProductFormSubmit(event) {
    var form = event.target;
    if (!form || !form.matches(selectors.productForm)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    await submitProduct(form, event.submitter && event.submitter.name === 'checkout');
  }

  function onBuyNowClick(event) {
    var button = event.target.closest('button[name="checkout"]');
    var form = button && button.closest(selectors.productForm);
    if (!form || button.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    submitProduct(form, true);
  }

  async function submitProduct(form, checkout) {

    if (form.dataset.cartDrawerSubmitting === 'true') return;
    if (window.matchMedia('(max-width: 767px)').matches &&
        form.querySelector('.product-options__list-view') &&
        form.dataset.mobileStickySizeConfirmed !== 'true') {
      form.dispatchEvent(new CustomEvent('product:require-size', { bubbles: true }));
      return;
    }
    form.dataset.cartDrawerSubmitting = 'true';
    var redirecting = false;

    setLoading(form, true);
    clearFormError(form);

    try {
      var addResponse = await addProductToCart(form);
      if (checkout) {
        redirecting = true;
        window.location.href = getCartUrl('checkout');
        return;
      }
      await refreshDrawer(addResponse && addResponse.sections);
      var cart = await getCart();
      updateCartCount(cart.item_count);
      emitCartUpdated(cart);
      openDrawer();
    } catch (error) {
      showFormError(form, error && (error.description || error.message) || 'Unable to add item to cart.');
      console.error('[CartDrawer] Add to cart failed:', error);
    } finally {
      if (!redirecting) {
        setLoading(form, false);
        delete form.dataset.cartDrawerSubmitting;
      }
    }
  }

  async function addProductToCart(form) {
    var variant = syncSelectedVariant(form);
    if (form.querySelector('[data-js-product-json]') && (!variant || !variant.available)) {
      throw new Error(window.ShopifyCurrentLanguage === 'hr'
        ? 'Odabrana kombinacija nije dostupna. Odaberite drugu veličinu.'
        : 'This combination is unavailable. Please select another size.');
    }

    var formData = new FormData(form);
    formData.set('sections', 'cart-drawer');
    formData.set('sections_url', window.location.pathname);

    var response = await fetch(getCartUrl('cart/add.js'), {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    });

    var data = await response.json();
    if (!response.ok || data.status) {
      throw data;
    }

    return data;
  }

  function syncSelectedVariant(form) {
    var variant = getSelectedVariant(form);
    var variantInput = form.querySelector('input[name="id"]');

    if (!variant || !variantInput) return null;

    variantInput.value = variant.id;
    variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    return variant;
  }

  function getSelectedVariant(form) {
    var productJson = form.querySelector('[data-js-product-json]');
    if (!productJson) return null;

    var product;
    try {
      product = JSON.parse(productJson.textContent);
    } catch (error) {
      console.warn('[CartDrawer] Could not parse product JSON:', error);
      return null;
    }

    var selectedOptions = getSelectedOptions(form);
    var optionCount = (product.options || []).length;
    if (!selectedOptions.length || selectedOptions.length !== optionCount || hasMissingOption(selectedOptions)) {
      return null;
    }

    return (product.variants || []).find(function (variant) {
      return selectedOptions.every(function (optionValue, index) {
        return variant.options[index] === optionValue || variant['option' + (index + 1)] === optionValue;
      });
    }) || null;
  }

  function getSelectedOptions(form) {
    var selected = [];

    form.querySelectorAll('[data-option]').forEach(function (input) {
      var optionName = input.getAttribute('data-option');
      var optionIndex = Number(String(optionName).replace('option', '')) - 1;

      if (Number.isNaN(optionIndex) || optionIndex < 0) return;

      if (input.tagName === 'SELECT') {
        selected[optionIndex] = input.value;
        return;
      }

      if ((input.type === 'radio' || input.type === 'checkbox') && input.checked) {
        selected[optionIndex] = input.value;
      }
    });

    return selected;
  }

  function hasMissingOption(selectedOptions) {
    for (var index = 0; index < selectedOptions.length; index++) {
      if (typeof selectedOptions[index] === 'undefined') {
        return true;
      }
    }

    return false;
  }

  async function refreshDrawer(sections) {
    var html = sections && sections['cart-drawer'];

    if (!html) {
      var response = await fetch(getSectionsUrl());
      var data = await response.json();
      html = data && data['cart-drawer'];
    }

    if (!html) return;

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nextDrawer = doc.querySelector(selectors.cartDrawer);
    var currentDrawer = document.querySelector(selectors.cartDrawer);

    if (!nextDrawer || !currentDrawer) return;

    currentDrawer.innerHTML = nextDrawer.innerHTML;
    currentDrawer.classList.toggle('is-empty', nextDrawer.classList.contains('is-empty'));
  }

  async function getCart() {
    var response = await fetch(getCartUrl('cart.js'), {
      headers: { 'Accept': 'application/json' }
    });

    if (!response.ok) {
      throw response;
    }

    return response.json();
  }

  function emitCartUpdated(cart) {
    if (!window.themeCore || !window.themeCore.EventBus || !cart) return;

    window.themeCore.cartObject = cart;
    window.themeCore.EventBus.emit('cart:updated', {
      ...cart,
      action: 'customAddToCart',
      params: [{ noOpen: true }]
    });
  }

  function openDrawer() {
    if (window.themeCore && window.themeCore.EventBus) {
      window.themeCore.EventBus.emit('cart:drawer:CartDrawer:open');
      window.themeCore.EventBus.emit('cart:drawer:open');
      return;
    }

    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      drawer.classList.add('is-active');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
    }
  }

  function updateCartCount(count) {
    document.querySelectorAll(selectors.cartCount).forEach(function (element) {
      element.textContent = count > 99 ? '99+' : count;
      if (element.hasAttribute('data-cart-count')) {
        element.setAttribute('data-cart-count', count);
      }
    });
  }

  function getCartUrl(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    root = root || '/';

    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function getSectionsUrl() {
    var url = new URL(window.location.href);
    url.searchParams.set('sections', 'cart-drawer');
    url.searchParams.set('lazyload', 'false');
    return url.toString();
  }

  function setLoading(form, isLoading) {
    form.querySelectorAll(selectors.submitButton).forEach(function (button) {
      if (isLoading) {
        button.dataset.cartDrawerWasDisabled = button.disabled ? 'true' : 'false';
      }

      button.classList.toggle('is-loading', isLoading);
      button.disabled = isLoading || button.dataset.available === 'false' || button.dataset.cartDrawerWasDisabled === 'true';

      if (!isLoading) {
        delete button.dataset.cartDrawerWasDisabled;
      }
    });
  }

  function clearFormError(form) {
    var error = form.querySelector(selectors.quantityError);
    var wrapper = form.querySelector(selectors.quantityErrorWrapper);
    if (error) error.textContent = '';
    if (wrapper) wrapper.classList.add('is-hidden');
  }

  function showFormError(form, message) {
    var error = form.querySelector(selectors.quantityError);
    var wrapper = form.querySelector(selectors.quantityErrorWrapper);
    if (error) error.textContent = message;
    if (wrapper) wrapper.classList.remove('is-hidden');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
